/* eslint-disable max-len */
import {AfterViewInit, ChangeDetectionStrategy, Component, DoCheck, ElementRef, NgZone, OnChanges, OnDestroy, Renderer2, SimpleChanges, ViewChild} from '@angular/core';

import { MENU_ITEMS, routeSkeleton } from './pages-menu';
import { NbMenuItem, NbToastrService } from '@nebular/theme';
import { ApiService } from '../@core/service/api.service';
import { interval, Subject, Subscription, takeUntil } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ErpRoles, UserModel } from '../@models';
import { NavigationStart, Router } from '@angular/router';
import * as moment from 'moment';
import { AuthGuardService } from '../@core/service/auth-guard.service';
import { RoleGuardService } from '../@core/service/role-guard.service';
import { PagesRoutingModule } from './pages-routing.module';
import { SharedDataService } from '../@core/service/shared-data.service';

@Component({
  selector: 'ngx-pages',
  template: `
    <ngx-sample-layout>
      <nb-menu [items]="menu"></nb-menu>
      <router-outlet></router-outlet>
    </ngx-sample-layout>
    <!-- <nrk-main-layout>
      <nb-menu [items]="getMenu(isAdmin, erpRoles)"></nb-menu>
      <router-outlet></router-outlet>
    </nrk-main-layout> -->
  `,
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PagesComponent implements OnDestroy, AfterViewInit {

  public menu = MENU_ITEMS;
  private autoLogout = { minutes: 120 };

  private isAdmin = false;
  private erpRoles: ErpRoles;

  // private currentUserSubscription: Subscription;
  private errorSubscription: Subscription;

  private currentUrl: string;
  private prevUrl: string;

  private destroy$ = new Subject<void>();
  private expiryEl: HTMLElement;


  constructor(private toastr: NbToastrService, private api: ApiService, private auth: AuthGuardService, private render: Renderer2, private router: Router, private data: SharedDataService, private ngZone: NgZone) {

    this.errorSubscription = this.api.error.subscribe((e) => {
      if (e instanceof HttpErrorResponse) {
        toastr.danger(e.error.message, e.error.name);
      } else {
        toastr.danger('Something went wrong');
        console.error(e);
      }
    });

    // this.currentUserSubscription = this.api.loadMe(true).subscribe(x => {
    this.router.events.subscribe(ev => {
      if (ev instanceof NavigationStart) {
        this.prevUrl = this.currentUrl;
        this.currentUrl = ev.url;
        this.checkExpired();
      }
    })
    this.currentUrl = router.url;
    this.checkExpired();
  }

  ngAfterViewInit(): void {
    this.auth.loadMe().then(user => {
      // this.erpRoles = x.erpRoles;
      // this.isAdmin = x.admin;
      PagesComponent.updateMenu(user)
      
      const items = document.getElementsByClassName('menu-items')[0];
      const li = items && items.getElementsByTagName('li');
      // console.log('menu background', this.menuRef, this.erpRoles, li)
      if (li) for (const i of li) {
        if (i.children[0]['title'].match(/nrka/i) && !i.children[0]['title'].match(/nrka.*nrkg/i)) {
          this.render.addClass(i, 'nrk-nrka-menu-background');
        }
        if (i.children[0]['title'].match(/nrkg/i) && !i.children[0]['title'].match(/nrka.*nrkg/i)) {
          this.render.addClass(i, 'nrk-nrkg-menu-background');
        }
      }

    });
    // this.ngZone.runOutsideAngular(() => {
    //   window.setInterval(() => {
    //     const sessionTime = +localStorage.getItem('session_time');
    //     const expired = moment(sessionTime*1000).utc().add(this.autoLogout).unix();
    //     const now = moment().utc().unix();
    //     const duration = moment.duration(expired - now, 'seconds');
    //     const hours = Math.floor(duration.asHours()).toString().padStart(2, '0');
    //     const minutes = duration.minutes().toString().padStart(2, '0');
    //     const secs = duration.seconds().toString().padStart(2, '0');
    //     // console.log('expires', expired - now);
    //     // console.log('expires', expired, sessionTime, now, duration, hours, minutes, secs, `${hours}:${minutes}:${secs}`)
    //     if (duration.asSeconds() <= 0) {
    //       this.router.navigate(['auth/logout']);
    //     }
    //     this.data.$expiryTime.next(`${hours}:${minutes}:${secs}`);
    //   }, 1000);
    // });

    this.expiryEl = document.querySelector('.expiry-time div');

    this.ngZone.runOutsideAngular(() => {
      interval(1000)
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => this.updateExpiryTime());
    });
  }

  private updateExpiryTime() {
    const sessionTime = +localStorage.getItem('session_time');
    const expired = moment(sessionTime * 1000).utc().add(this.autoLogout).unix();
    const now = moment().utc().unix();
    const duration = moment.duration(expired - now, 'seconds');

    const hours = Math.floor(duration.asHours()).toString().padStart(2, '0');
    const minutes = duration.minutes().toString().padStart(2, '0');
    const secs = duration.seconds().toString().padStart(2, '0');

    // Only navigate back inside Angular
    if (duration.asSeconds() <= 0) {
      this.ngZone.run(() => this.router.navigate(['auth/logout']));
    }
    if (this.expiryEl) {
      this.expiryEl.textContent = `Autologout: ${hours}:${minutes}:${secs}`;
    }
  }

  ngOnDestroy(): void {
    // this.currentUserSubscription.unsubscribe();
    this.errorSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  findMenuItem(ref: string, menuItems: any[], item = null) {
    menuItems.forEach(el => {
      if (el.link === ref || el.title === ref) {
        item = el;
      } else {
        if (el.children) item = item || this.findMenuItem(ref, el.children);
      }
    })
    return item;
  }

  static updateMenu(user: UserModel) {
    // const reports = this.menu.find(x => x.title === 'Reports');
    // const administration = this.menu.find(x => x.title === 'Administration');

    // const erp = [
    //   { ref: 'NR ERP', roles: ['admin', 'nrka', 'nrkg', 'products', 'reports'], antiRoles: ['loginAdmin'] },
    //   { ref: '/pages/erp/navigation', roles: ['admin', 'nrka', 'nrkg', 'products', 'reports'], antiRoles: ['offers'] },
    //   { ref: '/pages/erp/core', roles: ['admin'] },
    //   { ref: '/pages/erp/material', roles: ['admin', 'materials'], antiRoles: ['readOnlyProducts'] },
    //   { ref: '/pages/erp/offers', roles: ['offers'] },
    //   { ref: 'Base Product', roles: ['admin', 'products'], antiRoles: ['offers'] },
    //   { ref: 'Finished Product', roles: ['admin', 'products'], antiRoles: ['offers'] },
    //   { ref: 'Price Matrix NRKA', roles: ['admin', 'nrka'] },
    //   { ref: 'Document NRKA', roles: ['admin', 'nrka'] },
    //   { ref: 'Price Matrix NRKG', roles: ['admin', 'nrkg'] },
    //   { ref: 'Document NRKG', roles: ['admin', 'nrkg'] },
    //   { ref: '/pages/erp/reports', roles: ['admin', 'reports'] },
    //   { ref: 'Utilities', roles: ['admin'] },
    //   { ref: '/pages/warehousing', roles: ['warehousing'] },

    //   { ref: '/pages/dashboard', roles: ['dashboard'] },
    //   { ref: '/pages/news', antiRoles: ['noCrm', 'loginAdmin'] },
    //   { ref: '/pages/activity', antiRoles: ['noCrm', 'loginAdmin'] },
    //   { ref: '/pages/task', antiRoles: ['noCrm', 'loginAdmin'] },
    //   { ref: '/pages/myproject', antiRoles: ['noCrm', 'loginAdmin'] },
    //   { ref: '/pages/myoffer', antiRoles: ['noCrm', 'loginAdmin'] },
    //   { ref: '/pages/business', antiRoles: ['noCrm', 'loginAdmin'] },
    //   { ref: 'Reports', antiRoles: ['noCrm', 'loginAdmin'] },
    //   { ref: 'Administration', roles: ['admin', 'loginAdmin'], antiRoles: ['noCrm'] },
    //   { ref: '/pages/administration/region', antiRoles: ['loginAdmin'] },
    //   { ref: '/pages/administration/bu', antiRoles: ['loginAdmin'] },
    // ]
    function walkMenu(nodes: NbMenuItem[]) {
      
      nodes.filter(f => f.link).forEach(node => {
        
        const route = routeSkeleton.find(f => {
          const path = `/pages/${f.path}`.replace(/\:.*/, '').replace(/\/$/, '');
          let compare = node.link;
          return path.localeCompare(compare) === 0;
        })

        // if (!route) console.info('Missing or wrong route:', node.link);
        // console.log('check rights', node.link, route?.data, user.admin )

        if (route) {
          node.hidden = !RoleGuardService.checkRights(route.data, user);
        } else if (['Administration', 'Reports'].includes(node.title)) {
          node.hidden = !user.admin;
        }

        if (route?.path === 'devhelper') {
          node.hidden = true;
          if (['loiz@gmx.at'].includes(user.username)) node.hidden = false;
        }

        if (node.children?.length) walkMenu(node.children);
      })
    }

    walkMenu(MENU_ITEMS);
    // console.log('routes', routeSkeleton);
    // const dynamicMenu = this.menu.filter(item => {
    //   const route = routeSkeleton.find(f => `pages/${f.path}`.replace(/\:.*/, '').replace(/\//, '') === item.link);
    //   console.log('getMenu', item.link)
    //   return true;
    // })

    // const reports = MENU_ITEMS.find(x => x.title === 'Reports');
    // const administration = MENU_ITEMS.find(x => x.title === 'Administration');
    // const utilities = MENU_ITEMS.find(x => x.title === 'Utilities');

    // console.log('utilities', utilities, user.erpRoles)

    // if (reports != null) {
    //   reports.hidden = !user.admin;
    // }
    // if (administration != null) {
    //   administration.hidden = !user.admin;
    // }
    // if (utilities != null) {
    //   utilities.hidden = !user.erpRoles.admin;
    // }

  //   erp.forEach(el => {
  //     const menu = this.findMenuItem(el.ref, this.menu);

  //     // if (menu && erpRoles != null && el.ref) {
  //     //   menu.hidden = (el.roles && !el.roles.find(r => erpRoles[r] === true || erpRoles[r] > 0)) 
  //     //     || (el.antiRoles && !erpRoles.admin && el.antiRoles.find(r => erpRoles[r] === true || erpRoles[r] > 0));
  //     // }

      // const items = document.getElementsByClassName('menu-items')[0];
      // const li = items && items.getElementsByTagName('li');
      // // console.log('menu background', this.menuRef, this.erpRoles, li)
      // if (li) for (const i of li) {
      //   if (i.children[0]['title'].match(/nrka/i) && !i.children[0]['title'].match(/nrka.*nrkg/i)) {
      //     this.render.addClass(i, 'nrk-nrka-menu-background');
      //   }
      //   if (i.children[0]['title'].match(/nrkg/i) && !i.children[0]['title'].match(/nrka.*nrkg/i)) {
      //     this.render.addClass(i, 'nrk-nrkg-menu-background');
      //   }
      // }
    // });
    
  //   return this.menu;
  }

  checkExpired() {
    const sessionTime = +localStorage.getItem('session_time');
    const expired = moment(sessionTime*1000).utc().add(this.autoLogout).unix();
    const now = moment().utc().unix();
    if (this.currentUrl !== this.prevUrl) {
      if (now > expired && this.currentUrl !== '/auth/login') {
        localStorage.removeItem('auth_app_token');
        this.router.navigateByUrl('/auth/login');
      } else {
        localStorage.setItem('session_time', ''+now);
      }
    }

  }

}
